import React from "react";
import {
  useEffect,
  useState
} from "react";
import { useHistory } from "react-router-dom";

import $ from "jquery";
import moment from "moment-timezone";
import Pagination from "react-js-pagination";
import "../../assets/js/rating.js";
import SekletonGlobalCalendarListView from "../../loaders/SekletonGlobalCalendarListView";
import {
  GetSubjectEventPageWise,
} from "../../services/CalendarService";
import { RenderFeedAssessmentStatus } from "../ticket/StatusRender.js";
import { classStatusWidgets } from "./../common/Helper";
import GlobalCalendarListItem from "./GlobalCalendarListItem";
const stc = require('string-to-color');


$(document).on("click", ".class-list-row", function () {
  setTimeout(() => {
    $("input.rating[type=number], div.rating").each(function () {
      $(this).rating();
    });
  }, 100);
});
const GlobalCalendarListView = ({
  subjectId,
  status,
  startDateListView,
  endDateListView,
  filter,
  }) => {
  const location = useHistory();
  let sD = moment().startOf("week");
  let eD = moment().endOf("week");

  const [showMore, setShowMore] = useState(false);
  const [popupUpdate, setPopupUpdate] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [classes, setClasses] = useState([]);
  const [classesKey, setClassesKey] = useState([]);
  const [todayClass, setTodayClass] = useState([]);
  const [classData, setClassData] = useState({})
  const [showListLoading, setShowListLoading] = useState(false);

  const handlePageChange = (pageNumber) => {
    if (pageNumber) {
      setShowListLoading(true);
      setActivePage(pageNumber);
      GetSubjectEventPageWise({
        subjectId,
        pageNumber,
        itemsPerPage,
        status,
        startDateListView,
        endDateListView,
        filter:filter,
      })
        .then((res) => {
          setClasses(Object.values(res.data.finalArray));
          setClassesKey(Object.keys(res.data.finalArray));
          setTotalItems(res.data.length);
          // setting up the today data
          const today = new Date().toISOString().split('T')[0];
          const keys = Object.keys(res.data.finalArray);
          if (keys.includes(today)) {
            setTodayClass(Object.values(res.data.finalArray)[0]);    
          }

          setShowListLoading(false);
        })
        .catch((error) => {
          console.error("GlobalCalenderListView [handlePageChagne]", error)
        });
    }
  };

  useEffect(() => {
    if(subjectId.length > 0) {
      let pageNumber = 1;
      handlePageChange(pageNumber)
    }
  }, [subjectId.length, status, startDateListView,endDateListView, popupUpdate,filter]);
  const goToSubject= (qid,sid)=>{
    location.push(`/course/${qid}/subject/${sid}`);
  };

  const checkBorder = (data, index, item) => {
    const current = data?.[index];
    const next = data?.[index + 1];
    if(moment(item).format('DD MMM YYYY') === moment().format('DD MMM YYYY') && current){
      if (!next) return true;
      return false;
    }else{
      return false;
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (!todayClass || todayClass.length === 0) return;
      
      document.querySelectorAll('.class-live-border').forEach(item => {
        item.classList.remove('class-live-border');
      });
      
      let lastOpenItemId = null;
      
      for (let i = 0; i < todayClass.length; i++) {
        const row = todayClass[i];
        if (!row) continue;
        
        if (row.is_live) {
          lastOpenItemId = row.id;
        }
      }
      
      if (lastOpenItemId) {
        const element = document.getElementById(`item-${lastOpenItemId}`);
        if (element) {
          element.classList.add('class-live-border');
        } else {
          const alternativeElement = document.querySelector(`[id*="${lastOpenItemId}"]`);
          if (alternativeElement) {
            alternativeElement.classList.add('class-live-border');
          }
        }
      }
    }, 0);
  }, [todayClass]);
  

  return (
    <>
      {showListLoading && <SekletonGlobalCalendarListView/>} 
      {!showListLoading &&
      <div className="Class-Shedule-List-View">
        <div className="table-responsive">
          <table className="table Class-Shedule-main-table">
            <tbody>
              {classesKey && classesKey.map((item, index1) => {
                  let res = item.split(",");
                  return (
                    <tr key={item + index1}>
                      <td>
                        <table className="table table-bordered">
                          <thead className="thead-dark">
                            <tr>
                              <th colSpan="2">
                                {moment(item, ["YYYY-MM-DD"]).format("dddd, D MMMM 'YY")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {classes[index1] && classes[index1].map((row, index11) => {
                                if(row.category=='task'){
                                  return (
                                      <tr
                                        className={`class-list-row class-past-row assessment-list-row`}
                                        id={`item-${row.id}`}
                                        key={`item-${row.id}`}
                                      >
                                        <td>
                                            {
                                            moment.unix(row.open_date_time).format("YYYY-MM-DD") == moment.unix(row.close_date_time).format("YYYY-MM-DD") ? 
                                            (moment.unix(row.open_date_time).format("h:mm A")+"-"+moment.unix(row.close_date_time).format("h:mm A")):
                                            moment.unix(row.open_date_time).format("YYYY-MM-DD") == item ?
                                            (moment.unix(row.open_date_time).format("h:mm A")):
                                            (moment.unix(row.close_date_time).format("h:mm A"))
                                            }
                                            <div>
                                              <br/>
                                              {row?.is_upcoming ? RenderFeedAssessmentStatus("pending").html : row?.is_past ? RenderFeedAssessmentStatus("closed").html : RenderFeedAssessmentStatus("open").html}
                                            </div>
                                        </td>
                                        <td className={`${row.category == "task" && (row?.is_upcoming ? "" : row?.is_past ? "assessment-list-row-color-red" : "assessment-list-row-color-blue")}`}>
                                            <GlobalCalendarListItem row={row} itemType="assessment" />
                                        </td>
                                      </tr>
                                )
                                }else if(row.category=='time'){
                                return (row.canceled == 1 || (row.started_at == 0 && row.is_past)) ? ( 
                                      <tr
                                        className={`class-list-row class-canceled-row`}
                                        id={`item-${row.id}`}
                                        key={row.id + "" + index11}
                                      >
                                        <td className="class-canceled-row-td">
                                          {row.class_from}-{row.class_to}
                                        </td>
                                        <td>
                                        <div className="class-list-data">
                                        <div className="meeting-title system-bot-inner-R-title gapCustom-8">

                                              {row.class_type == "hybrid" ? (
                                                  <>
                                                      <h6 className="meeting-title lb-black pb-xl-0">
                                                          {row.class_title}
                                                      </h6>
                                                          <small className="tag class-status-tag">
                                                              <i className="fal fa-university"></i>{" "}
                                                              <i className="fal fa-plus"></i>{" "}
                                                              <i className="fal fa-house-signal"></i>Hybrid
                                                          </small>
                                                  </>
                                              ) : row.class_type == "on_campus" ? (
                                                  <>
                                                      <h6 className="meeting-title lb-black pb-xl-0">
                                                          {row.class_title}
                                                      </h6>
                                                      <small className="tag-purple class-status-tag">
                                                          <i className="fal fa-university"></i> On Campus
                                                      </small>
                                                  </>
                                              ) : (
                                                  <div className="virtal-class-row gapCustom-8">

                                                      <h6 className="meeting-title lb-black pb-xl-0">
                                                          {row.class_title}
                                                      </h6>
                                                      <small className="tag-green class-status-tag">
                                                          <i className="fal fa-house-signal"></i> Virtual
                                                      </small>

                                                  </div>)
                                              }
                                          <small>
                                          {classStatusWidgets("cancelled")}
                                          </small>
                                        </div>
                                        </div>
                                        </td>
                                      </tr>
                                    
                                ) : row.is_past ? (
                                  //Past Classes
                                  <>
                                      <tr
                                        className={`class-list-row class-past-row`}
                                        key={row.id + "" + index11}
                                        id={`item-${row.id}`}
                                      >
                                        <td>
                                          {row.class_from}-{row.class_to}
                                        </td>
                                        <td>
                                        <GlobalCalendarListItem row={row} itemType="class" classtype="past" classData={classData} setClassData={setClassData} classes={classes} setPopupUpdate={setPopupUpdate}/>
                                        </td>
                                      </tr>
                                    
                                  </>
                                ) : row.is_live ? (
                                  //Live Classes
                                  
                                      <tr 
                                        className={`class-list-row class-live-row`}
                                        key={row.id + "" + index11}
                                        id={`item-${row.id}`}
                                      >
                                        <td>
                                          {row.class_from}-{row.class_to}
                                        </td>
                                        <td>
                                        <GlobalCalendarListItem row={row} itemType="class" classtype="live" classData={classData} setClassData={setClassData} classes={classes} setPopupUpdate={setPopupUpdate}/>
                                       </td>
                                      </tr>
                                   
                                ) : (
                                  //Upcoming Classes
                                      <tr
                                        className={`class-list-row class-upcoming-row`}
                                        key={row.id + "" + index11}
                                        id={`item-${row.id}`}
                                      >
                                        <td>
                                          {row.class_from}-{row.class_to}
                                        </td>
                                        <td>
                                        <GlobalCalendarListItem row={row} itemType="class" classtype="upcoming" classes={classes} setPopupUpdate={setPopupUpdate} />
                                        </td>
                                      </tr>
                                    );
                              }
                              })}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  );
                })}
              {classesKey.length == 0 && (
                <tr>
                  <td>
                    <table className="table table-bordered">
                      <thead className="thead-dark">
                        <tr>
                          <th>No classes found.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="class-list-row">
                          <td>
                            We could not find any classes. Please confirm with
                            your Support Team or try again later.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      }
      {(status == "past" || status == "upcoming") && classesKey.length > 0 ? (
        <div className="class-list-view-pagination mt-3">
          <Pagination
            activePage={activePage}
            itemsCountPerPage={itemsPerPage}
            totalItemsCount={totalItems}
            pageRangeDisplayed={5}
            onChange={(pageNumber) => handlePageChange(pageNumber)}
            itemClass="page-item"
            linkClass="page-link"
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default GlobalCalendarListView;
